// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"395cd066","112":"225323d6","152":"c9bbd7ff","281":"4ad60737","376":"6827dcea","424":"66af8acf","435":"45b3e608","575":"833f126b","590":"5967be2e","742":"80f10d58","787":"7da95b79","797":"cd8a9c72","815":"1267367b","950":"e064a2a4","959":"e77e0f02","986":"0a458cc3"}[chunkId] + ".chunk.js";
};